import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import infoImg from '../../extensions/images/winners/info.jpg';

const FormInstruction = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        title="Form instruction"
        style={{
          position: "absolute",
          right: "20px",
          top: "90px",
          color: "#1976d2"
        }}
      >
        <HelpOutlineIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent dividers>
          <img
            src={infoImg}
            alt="form instruction"
            style={{
              width: '100%',
              maxWidth: 740,
              display: 'block',
              margin: '0 auto'
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FormInstruction;